import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { CREATE_EQUIPMENT } from 'src/store/actions/equipmentsActions';

import StepOne from './StepOne';
import StepTwo from './StepTwo';
import FinalStep from './FinalStep';

const CurrentStep = ({
  activeStep,
  data,
  onNext,
  onBack,
  onSubmit,
  resetRef,
  setData
}) => {
  const loading = useSelector(isLoadingSelector([CREATE_EQUIPMENT.action]));

  if (activeStep === 0) {
    return (
      <StepOne
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
        setData={setData}
      />
    );
  }

  if (activeStep === 1) {
    return (
      <StepTwo
        data={data}
        handleNext={onNext}
        handleBack={onBack}
        resetRef={resetRef}
      />
    );
  }

  return (
    <FinalStep
      data={data}
      loading={loading}
      handleBack={onBack}
      handleSubmit={onSubmit}
      resetRef={resetRef}
    />
  );
};

CurrentStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
  data: PropTypes.any.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  resetRef: PropTypes.any.isRequired,
  setData: PropTypes.func.isRequired,
};

export default CurrentStep;
